module.exports = __webpack_public_path__ + "static/onpony-desk-bb9fdf53fbac73022c936f4088d0d930.png";